import React from 'react'
import Navbar from '../HomePage/Navbar'
import Footer from '../HomePage/Footer'
import PaintingServices from './PaintingServices'
function PaintingIndex() {
  return (
    <div>
        <Navbar />
      <PaintingServices />

        <Footer />
    </div>
  )
}

export default PaintingIndex
